import { BonusClassification, BonusSettlementType, OrderType } from '@synergy/models';

import { findDocumentStatusTranslationId } from './get-document-status-translation-id';

/**
 * The wording of the values a filter catalogue hands out, beside the statuses.
 *
 * A list declares which values a choice takes, not what they are called — the
 * wording of a value lives in the translation file, in one place, the same one
 * the column underneath reads. Without this the filter and its chip showed the
 * constant: "Typ TYPE_MANUAL" where the column beside it said "POOL"
 * (#2231 R-120).
 */
const translationObject: Record<string, string> = {
    [OrderType.Manual]: 'app.orderType.manual',
    [OrderType.Shop]: 'app.orderType.shop',
    [OrderType.Anonymous]: 'app.orderType.anonymous',
    [OrderType.SingleInquiry]: 'app.orderType.singleinquiry',
    [BonusClassification.Contract]: 'app.bonusClassification.contract',
    [BonusClassification.Bonus]: 'app.bonusClassification.bonus',
    [BonusClassification.BonusPlus]: 'app.bonusClassification.bonusPlus',
    [BonusSettlementType.Main]: 'app.bonusSettlement.type.mainSettlement',
    [BonusSettlementType.Reclaim]: 'app.bonusSettlement.type.reclaim',
};

/**
 * The label of a value a filter offers, or nothing when it has none.
 *
 * Nothing rather than the value itself, so a caller can tell a value it can
 * name from one it can only show.
 */
export const findFilterValueTranslationId = (value?: string): string | undefined =>
    value ? findDocumentStatusTranslationId(value) ?? translationObject[value] : undefined;
